// eslint-disable-next-line no-restricted-imports
import _ from 'lodash';

import { isEmpty } from './lib/isEmpty';
import { omit } from './lib/omit';
import { get } from './lib/get';
import { first } from './lib/first';
import { last } from './lib/last';
import { partition } from './lib/partition';
import { trunc } from './lib/trunc';
import { uniq } from './lib/uniq';
import { set, setWithObject } from './lib/set';
import { partial } from './lib/partial';
import { escape } from './lib/escape';
import { escapeRegExp } from './lib/escapeRegExp';
import { difference } from './lib/difference';
import { intersection } from './lib/intersection';
import { chunk } from './lib/chunk';
import { inRange } from './lib/inRange';
import { camelCase } from './lib/camelCase';
import { capitalize } from './lib/capitalize';
import { snakeCase } from './lib/snakeCase';
import { kebabCase } from './lib/kebabCase';
import { clamp } from './lib/clamp';
import { pickBy } from './lib/pickBy';

const lodashFunctions = {
    /** @deprecated isEmpty() is too ambiguous, explicitly check for a property or the length, isEmpty has unexpected behaviour
     * with booleans and numbers
     * _.isEmpty(true) => true
     * _.isEmpty(1) => true
     */
    isEmpty,
    /** @deprecated Use native spread operator: `const { a, c, ...result2 } = object;` */
    omit,
    get,
    /** @Todo create local implementation or add lodash package */
    isEqual: _.isEqual as (typeof _)['isEqual'],
    /** @Todo create local implementation or add lodash package */
    isPlainObject: _.isPlainObject as (typeof _)['isPlainObject'],
    first,
    last,
    noop: () => {
        // noop
    },
    partition,
    trunc,
    /** @Todo create local implementation or add lodash package */
    template: _.template as (typeof _)['template'],
    uniq,
    set,
    setWithObject,
    /** @Todo create local implementation or add lodash package */
    has: _.has as (typeof _)['has'],
    partial,
    /** @Todo create local implementation or add lodash package */
    debounce: _.debounce as (typeof _)['debounce'],
    /** @Todo create local implementation or add lodash package */
    transform: _.transform as (typeof _)['transform'],
    /** @Todo create local implementation or add lodash package */
    merge: _.mergeWith as (typeof _)['mergeWith'],
    escape,
    escapeRegExp,
    difference,
    intersection,
    chunk,
    /** @Todo create local implementation or add lodash package */
    sortByOrder: _.orderBy as (typeof _)['orderBy'],
    /** @Todo create local implementation or add lodash package */
    bindAll: _.bindAll as (typeof _)['bindAll'],
    /** Use deep clone from luna/utils unless you are copying RegExp objects/functions/circular structures */
    cloneComplexStructureDeep: _.cloneDeep as (typeof _)['cloneDeep'],
    inRange,
    /** @Todo create local implementation or add lodash package */
    pull: _.pull as (typeof _)['pull'],
    /** @Todo create local implementation or add lodash package */
    throttle: _.throttle as (typeof _)['throttle'],
    camelCase,
    capitalize,
    snakeCase,
    kebabCase,
    /** @Todo create local implementation or add lodash package */
    isMatch: _.isMatch as (typeof _)['isMatch'],
    /** @Todo create local implementation or add lodash package */
    unescape: _.unescape as (typeof _)['unescape'],
    /** @Todo create local implementation or add lodash package */
    defaultsDeep: _.defaultsDeep as (typeof _)['defaultsDeep'],
    clamp,
    pickBy,
    /** @Todo Below are functions used by Cypress */
    sample: _.sample as (typeof _)['sample'],
    times: _.times as (typeof _)['times'],
    mapValues: _.mapValues as (typeof _)['mapValues'],
    union: _.union as (typeof _)['union'],
    isFinite: _.isFinite as (typeof _)['isFinite'],
    isBoolean: _.isBoolean as (typeof _)['isBoolean'],
    omitBy: _.omitBy as (typeof _)['omitBy'],
    cloneDeep: _.cloneDeep as (typeof _)['cloneDeep'],
    find: _.find as (typeof _)['find'],
    mapKeys: _.mapKeys as (typeof _)['mapKeys'],
};

const lodash = {
    _: lodashFunctions,
    ...lodashFunctions,
} as const;

export default lodash;
